import { ESIInclude } from "@packages/esi-include/ESIInclude";
import styles from "./Header.module.scss";

export function Header() {
  const headerBaseUrl = process.env.NEXT_PUBLIC_HEADER_PROXY
    ? "/header-proxy"
    : "";
  const srcUrl = `${headerBaseUrl}/scaffold/header.html?includeCoreCSS=false&includeCoreJS=false&includePolyfills=false&stickySearchHeader=true`;

  return (
    <div
      data-testid="header"
      data-component="Header"
      className={styles.headerWrapper}
    >
      <ESIInclude src={srcUrl} id="header" />
    </div>
  );
}
